//@ts-nocheck
import * as React from 'react';
import { connect } from 'react-redux';
import * as d3 from 'd3';
import * as topojson from 'topojson';
import { MapWrapperProps, MapWrapperState } from '../../interface/MapInterface';
import { schemePurples, schemeBlues } from "d3-scale-chromatic";
import MapTooltip from "./MapTooltip";
import Map from "./Map";
import MapLegend from './MapLegend';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import ZoomHelp from "../reports/SpendingReport/ZoomHelp";

import { getDetailedDistrictReportDisplayData, downloadDetailedDistrictReport, setSelectedDistrictId, getAllSpending } from './../../actions/DetailedDistrictReportActions';

const us: { arcs: any, objects: any } = require("./us.json");
const states: { arcs: any, objects: any } = require("./cb_2024_us_state_20m.json");
const counties: { arcs: any, objects: any } = require("./cb_2024_us_county.json");//cb_2018_us_county_20m
const districts: { arcs: any, objects: any } = require("./cb_2024_us_cd119_20m.json");//USA_CD119

class MapContainer extends React.Component<MapWrapperProps, MapWrapperState> {
    state = {
        landBoundary: {
            type: "", geometry: {}, properties: {}
        },
        shapeData: { type: "", features: [] },
        hover: false,
        hoverFeature: null,
        tooltipData: [],
        tooltipPosition: { left: null, top: null },
        tablename: "all",
        zoomTransform: null
    };

    zoomed = (e) => {
        this.setState(() => ({ zoomTransform: e.transform }))
    }

    zoom = d3.zoom()
        .scaleExtent([1, 8])
        .on("zoom", this.zoomed);

    getZoomScaleExtent = (): [number, number] => {
        const isNationalCountyMap = !this.props.isCongress && !this.props.isInState && !this.props.isEmployee;
        return isNationalCountyMap ? [0.85, 8] : [1, 8];
    }

    getZoomViewportExtent = (): [[number, number], [number, number]] => {
        return [[0, 0], [this.mapAreaWidth, this.mapAreaHeight]];
    }

    getZoomTranslateExtent = (shapeData?: { features?: any[] }): [[number, number], [number, number]] => {
        const data = shapeData || this.state.shapeData;
        if (!data?.features?.length) {
            return this.getZoomViewportExtent();
        }

        const bounds = this.getGeoPath(data).bounds(data);
        return [[bounds[0][0], bounds[0][1]], [bounds[1][0], bounds[1][1]]];
    }

    configureZoom = (shapeData?: { features?: any[] }) => {
        if (!this.mapArea) return;

        d3.select(this.mapArea).call(
            this.zoom
                .scaleExtent(this.getZoomScaleExtent())
                .translateExtent(this.getZoomTranslateExtent(shapeData))
                .extent(this.getZoomViewportExtent())
        );
    }

    getNationalCountyProjectionScale = () => {
        // AlbersUsa scale was 700 at 500px map width; scale down with narrower canvas
        return Math.round(700 * (this.mapAreaWidth / 500));
    }

    getZoomDisplaySize = () => {
        const height = 500;
        const width = Math.round(this.mapAreaWidth * (height / this.mapAreaHeight));
        return {
            width: Math.min(900, width),
            height
        };
    }

    getSvgViewBox = () => {
        if (this.props.isZoomed || this.props.isCongress) {
            return `0 0 ${this.mapAreaWidth} ${this.mapAreaHeight}`;
        }
        return this.viewBox;
    }

    mapArea: SVGAElement;


    activePath = d3.select(null);

    // Track last congress ID we fetched to avoid redundant re-fetches during re-renders (e.g., hover)
    lastFetchedCongressId: string = null;


    colorScheme = this.props.isEmployee
        ? schemeBlues[8]
        : this.props.agg
            ? schemePurples[7].slice(2)
            : schemePurples[5];

//    mapAreaWidth = this.props.state_fips == '02' ? 600 : (this.props.isDetailedDistrict) ? 680 : (this.props.isEmployee) ? 700 : (this.props.isZoomed) ? 900 : this.props.isInState ? (this.props.factSheet ? 450 : 400) : ((this.props.isCongress) ? 750 : 500);
//    mapAreaHeight = this.props.state_fips == '02' ? 500 : (this.props.isDetailedDistrict) ? 450 : (this.props.isEmployee) ? 450 : (this.props.isZoomed) ? 500 : (this.props.factSheet ? 720 : 330);

    mapAreaWidth = this.props.state_fips == '02' ? 600 : (this.props.isDetailedDistrict) ? 680 : (this.props.isEmployee) ? 700 : this.props.isInState ? (this.props.factSheet ? 680 : (this.props.isCongress ? 750 : 400)) : ((this.props.isCongress) ? 750 : 400);
    mapAreaHeight = this.props.state_fips == '02' ? 500 : (this.props.isDetailedDistrict) ? 450 : (this.props.isEmployee) ? 450 : (this.props.factSheet ? 520 : 330);


    //viewBox = this.props.state_fips == '02' ? "0 0 600 500" :
    //    this.props.isDetailedDistrict ? "0 0 600 500" :
    //        this.props.isZoomed ? "0 0 1100 500" :
    //            this.props.isEmployee ? "0 0 700 450" :
    //                this.props.factSheet ? "0 0 595 615" : "0 0 500 400"

    viewBox = this.props.state_fips == '02' ? "0 0 600 500" :
        this.props.isDetailedDistrict ? "0 0 900 500" :
                this.props.isEmployee ? "0 0 700 450" :
                    this.props.factSheet ? "0 0 680 520" : "0 0 500 400"


    legendBoxPadding = 5;
    legendCellHeight = this.props.isZoomed ? 20 : 10;
    legendLineHeight = this.props.isZoomed ? 20 : 15;

    mapAreaRef = node => {
        this.mapArea = node;
    }

    getSpending() {
        if (!this.props.isCongress) {
            return this.props.isInState
                ? this.props.mapData.filter(d => d.statecode == this.props.state_fips).filter(d => d.tablename == this.state.tablename)
                : this.props.mapData.filter(d => d.tablename == this.state.tablename);
        } else {
            return this.props.isInState
                ? this.props.mapData.filter(d => {
                    d.congress_id = "0".repeat(4 - d.congress_id.length) + d.congress_id;
                    return +d.congress_id.slice(0, 2) == this.props.state_fips;
                })
                    .filter(d => d.tablename == this.state.tablename)

                : this.props.mapData.filter(d => d.tablename == this.state.tablename);
        }

    }

    // Log-spaced integer ranges for counts >= 5 (non-overlapping, closed). Always returns k ranges when possible.
    logSpacedEmployeeRanges(values, k) {
        if (!values.length) return [];

        const dataMax = Math.max(...values);
        k = Math.min(k, new Set(values).size);
        if (k <= 1) return [{ lo: 5, hi: dataMax }];

        const logMin = Math.log10(Math.min(...values));
        const logMax = Math.log10(dataMax);

        const ranges = [];
        let lo = 5;
        for (let i = 1; i < k; i++) {
            let hi = Math.floor(Math.pow(10, logMin + (logMax - logMin) * (i / k)));
            // Leave at least one integer for each remaining bucket (including the last).
            const maxHi = dataMax - (k - i);
            if (hi > maxHi) hi = maxHi;
            if (hi < lo) hi = lo;
            ranges.push({ lo, hi });
            lo = hi + 1;
        }
        ranges.push({ lo, hi: dataMax });
        return ranges;
    }

    // Same matching as Map.tsx (statecode is int; GEOID is zero-padded string).
    employeeFipsMatch = (fips, geoid) => fips == geoid;

    // Rows that contribute to the visible map (exclude state-total *000 rows in state view).
    employeeMapData = () => {
        const data = this.props.mapData || [];
        if (this.props.isInState) {
            return data.filter(d =>
                d.statecode == this.props.state_fips && !String(d.fips).endsWith("000"));
        }
        return data.filter(d => !this.employeeFipsMatch(d.fips, this.props.state_fips));
    }

    // Evenly sample distinct blues from palette[startIdx..].
    pickEmployeeLogColors(k, startIdx = 0) {
        const palette = this.colorScheme.slice(startIdx);
        if (!k || !palette.length) return [];
        k = Math.min(k, palette.length);
        if (k === 1) return [palette[Math.floor(palette.length / 2)]];
        if (k === palette.length) return palette.slice();
        return Array.from({ length: k }, (_, i) =>
            palette[Math.round(i * (palette.length - 1) / (k - 1))]
        );
    }

    buildEmployeeColorScale() {
        const ZERO_COLOR = '#FFFFFF';
        const mapData = this.employeeMapData();
        const features = this.state.shapeData?.features || [];
        const allData = this.props.mapData || [];
        // Puerto Rico is in the shapefile but not drawn by geoAlbersUsa.
        const hasZero = features.some(f => {
            const geoid = f.properties.GEOID;
            if (!this.props.isInState && geoid == '72') return false;
            return !allData.some(d => this.employeeFipsMatch(d.fips, geoid));
        });
        const hasMasked = mapData.some(d => d.count <= 4);
        const counts5Plus = mapData.map(d => d.count).filter(c => c >= 5);

        // White zero doesn't consume a blue. Fill remaining palette slots with log bins.
        const MASKED_COLOR = this.colorScheme[0];
        const logStartIdx = hasMasked ? 1 : 0;
        const specialCount = (hasZero ? 1 : 0) + (hasMasked ? 1 : 0);
        const maxLogBins = Math.max(1, this.colorScheme.length - specialCount);
        const logRanges = this.logSpacedEmployeeRanges(counts5Plus, maxLogBins);
        const logColors = this.pickEmployeeLogColors(logRanges.length, logStartIdx);

        const buckets = [];
        if (hasZero) {
            buckets.push({ color: ZERO_COLOR, label: '0', kind: 'zero' });
        }
        if (hasMasked) {
            buckets.push({ color: MASKED_COLOR, label: '<5 (masked for privacy)', kind: 'masked' });
        }
        logRanges.forEach((range, i) => {
            const label = range.lo === range.hi
                ? range.lo.toLocaleString('en-US')
                : `${range.lo.toLocaleString('en-US')} to ${range.hi.toLocaleString('en-US')}`;
            buckets.push({ ...range, color: logColors[i], label, kind: 'log' });
        });

        const scale = (value) => {
            if (value == null) return ZERO_COLOR;
            const n = +value;
            if (n <= 4) return MASKED_COLOR;
            const match = buckets.find(b => b.kind === 'log' && n >= b.lo && n <= b.hi);
            return match ? match.color : logColors[logColors.length - 1];
        };

        scale.employeeLegend = () => [...buckets].reverse().map(b => ({
            color: b.color,
            label: b.label
        }));

        return scale;
    }

    getColorScale() {
        if (!this.props.isEmployee) {
            const spending = this.getSpending();
            const spendingUniqueArray = [
                ...new Set(spending.map(location => location[!this.props.isCongress ? "total" : "payment_amt"]))
            ];
            const spendingThresholds = [50000, 250000, 500000, 1000000];
            const congressThresholds = [250000, 1000000, 5000000, 10000000]

            if (this.props.agg) {
                if (this.props.isCongress) {
                    return d3.scaleThreshold().domain(congressThresholds).range(this.colorScheme);
                } else {
                    return d3.scaleThreshold().domain(spendingThresholds).range(this.colorScheme);
                }
            } else {
                return d3.scaleQuantile().domain(spendingUniqueArray).range(this.colorScheme);
            }
        }
        return this.buildEmployeeColorScale();
    }

    handleMouseEnter = (match, feature) => (e) => {
        const containerRect = this.mapArea.getBoundingClientRect();
        const relativeX = e.clientX - containerRect.x;
        const relativeY = e.clientY - containerRect.y;
        const left = `${relativeX}px`;
        const top = `${relativeY > this.mapAreaHeight / 2 ? relativeY - 100 : relativeY + 50}px`;

        this.setState(() => ({
            hover: true,
            hoverFeature: feature,
            tooltipData: match,
            tooltipPosition: { left, top }
        }))
    }

    handleMouseLeave = () => {
        this.setState(() => ({ hover: false }))
    }

    handleChange = (tablename) => {
        this.setState(() => ({ tablename }))
    }

    setStuffOnDropdownChange = () => {
        if (this.props.selectedCongressId != undefined) {
            let congressId = this.props.selectedCongressId

            const feature = this.state.shapeData.features.find(x => x.properties.GEOID == congressId);
            const pathId = "#path-" + congressId;

            this.activePath.classed("active", false);
            this.activePath = d3.select(pathId).classed("active", true);
            const bounds = this.getGeoPath(this.state.shapeData).bounds(feature),
                dx = bounds[1][0] - bounds[0][0],
                dy = bounds[1][1] - bounds[0][1],
                x = (bounds[0][0] + bounds[1][0]) / 2,
                y = (bounds[0][1] + bounds[1][1]) / 2,
                scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.mapAreaWidth, dy / this.mapAreaHeight))),
                translate = [this.mapAreaWidth / 2 - scale * x, this.mapAreaHeight / 2 - scale * y];

            // Only fetch if the selected district actually changed
            if (this.lastFetchedCongressId !== congressId) {
                this.lastFetchedCongressId = congressId;
                this.props.getDetailedDistrictReportDisplayData(this.props.UserState.report_display_id, congressId, this.props.UserState.report_vintage_one_district);
            }
        }
    }

    handleClick = (feature) => (e) => {
        // Fact sheet congressional maps should be hover-only (no persistent click selection)
        if (this.props.factSheet && this.props.isCongress) {
            return;
        }

        if (this.props.isCongress) {
            let congressId = feature.properties.STATEFP + feature.properties.CD119FP
            //let congressId = feature.properties.state + feature.properties.CD118

            // set selected congressional district id in state
            this.props.setSelectedDistrictId(congressId);

            // load Detailed District Report top bullet points when clicked
            this.lastFetchedCongressId = congressId;
            this.props.getDetailedDistrictReportDisplayData(this.props.UserState.report_display_id, congressId, this.props.UserState.report_vintage_one_district);
        }

        if (this.props.isEmployee) {
            this.props.employeeMapClick({ statecode: +feature.properties.GEOID, name: feature.properties.NAME });
        }
        else {
            if (this.activePath.node() === e.target) return this.reset();
            this.activePath.classed("active", false);
            this.activePath = d3.select(e.target).classed("active", true);
            const bounds = this.getGeoPath(this.state.shapeData).bounds(feature),
                dx = bounds[1][0] - bounds[0][0],
                dy = bounds[1][1] - bounds[0][1],
                x = (bounds[0][0] + bounds[1][0]) / 2,
                y = (bounds[0][1] + bounds[1][1]) / 2,
                scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.mapAreaWidth, dy / this.mapAreaHeight))),
                translate = [this.mapAreaWidth / 2 - scale * x, this.mapAreaHeight / 2 - scale * y];

            if (!this.props.isCongress) {
                d3.select(this.mapArea).transition()
                    .duration(750)
                    .call(this.zoom.transform, d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale))
            }
        }
    }

    reset = () => {
        this.activePath.classed("active", false);
        this.activePath = d3.select(null);

        d3.select(this.mapArea).transition()
            .duration(750)
            .call(this.zoom.transform, d3.zoomIdentity);
    }

    createBoundary = () => {
        if (!this.props.isInState) {
            return topojson.feature(us, us.objects.land);
        }

        const matchState = topojson.feature(states, {
            type: "GeometryCollection",
            geometries: states.objects.cb_2024_us_state_20m.geometries.filter(
                d => +d.properties.STATEFP == this.props.state_fips
            )
        });
        return matchState.features[0];
    }

    createShapeData = () => {
        if (this.props.isCongress) {
            return this.props.isInState
                ? topojson.feature(districts, {
                    type: "GeometryCollection",
                    geometries: districts.objects.cb_2024_us_cd119_20m.geometries.filter(
                        d => +d.properties.STATEFP == this.props.state_fips
                    )
                })
                : topojson.feature(districts, districts.objects.cb_2024_us_cd119_20m);
        }

        // Counties/States logic for non-congress maps
        if (this.props.isInState) {
            // State view: always use counties
            return topojson.feature(counties, {
                type: "GeometryCollection",
                geometries: counties.objects.cb_2024_us_county_20m.geometries.filter(
                    d => +d.properties.STATEFP === this.props.state_fips
                )
            });
        } else {
            // National view: employees use states, others use counties
            return this.props.isEmployee
                ? topojson.feature(states, states.objects.cb_2024_us_state_20m)
                : topojson.feature(counties, counties.objects.cb_2024_us_county_20m);
        }
    }

    getGeoPath = (referenceObj?: {}) => {
        let projection;
        // Use shapeData as the consistent reference for fitting
        const fitToObj = referenceObj || this.state.shapeData;

        if (this.props.isEmployee) {
            if (this.props.isInState) {
                const fitBounds: [[number, number], [number, number]] =
                    [[0, 10], [this.mapAreaWidth, this.mapAreaHeight]];
                projection = +this.props.state_fips === 2
                    ? d3.geoTransverseMercator().rotate([135 + 50 / 60, -30 - 30 / 60]).fitExtent(fitBounds, fitToObj)
                    : d3.geoMercator().fitExtent(fitBounds, fitToObj);
            } else {
                projection = d3.geoAlbersUsa().scale(900).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2]);
            }
        } else {
            const fitBounds = this.props.factSheet && this.props.isCongress
                ? [[0, 10], [this.mapAreaWidth - 235, this.mapAreaHeight - 20]]
                : [[0, 10], [this.mapAreaWidth, this.mapAreaHeight]];

            projection = this.props.state_fips == '02'
                ? d3.geoTransverseMercator().rotate([135 + 50 / 60, -30 - 30 / 60]).fitExtent(fitBounds, fitToObj)
                : this.props.isInState
                    ? d3.geoMercator().fitExtent(fitBounds, fitToObj)
                    : this.props.isCongress
                        ? d3.geoAlbersUsa().scale(700).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2])
                        : d3.geoAlbersUsa().scale(this.getNationalCountyProjectionScale()).translate([this.mapAreaWidth / 2, this.mapAreaHeight / 2]);
        }
        return d3.geoPath().projection(projection);
    }

    updateMapBoundary = () => {
        const shapeData = this.createShapeData();
        const landBoundary = this.createBoundary();

        this.setState(() => ({
            shapeData,
            landBoundary
        }));
        this.configureZoom(shapeData);
    }
    componentDidUpdate(prevProps) {
        if (this.props.isInState !== prevProps.isInState ||
            this.props.state_fips !== prevProps.state_fips) {
            this.updateMapBoundary();
        }
    }

    componentDidMount() {
        this.updateMapBoundary();
    }

    homeStateEmployeeCount = this.props.isEmployee && this.props.mapData.filter(state => state.fips == this.props.state_fips).map(state => state.count);
    
    otherStateEmployeeCounts = () => {
        //console.log(this.props.mapData)
        //console.log(this.props)
        return (this.props.isInState == true) ?
            this.props.mapData.filter(state => state.statecode == this.props.state_fips &&
                !String(state.fips).endsWith("000")).map(state => state.count).sort((a, b) => b - a).filter(num => num !== 0)
                :
            this.props.mapData.filter(state => state.fips != this.props.state_fips.toString()).map(state => state.count).sort((a, b) => b - a).filter(num => num !== 0);
    }
        

    render() {
        console.log('Available state objects:', Object.keys(states.objects));
        console.log(counties);
        console.log(this.props)
        if (this.props.isDetailedDistrict && this.props.isCongress) {
            this.setStuffOnDropdownChange();
        }

        let clipPathId = this.props.isInState ? 'county-state' : 'county-nation';
        let chartNo;
        if (this.props.isCongress) {
            chartNo = 5;
            if (this.props.isZoomed) {
                clipPathId = this.props.isInState ? 'zoomed-state' : 'zoomed-nation'
            } else {
                clipPathId = this.props.isInState ? "state" : 'nation';
            }
        } else {
            chartNo = 3;
        }

        //console.log('landBoundary:', this.state.landBoundary);
        //console.log('clipPathId:', clipPathId);

        // Check if we can generate the path
        //if (this.state.landBoundary && this.state.landBoundary.geometry) {
        //    const pathString = this.getGeoPath(this.state.landBoundary)(this.state.landBoundary.geometry);
        //    console.log('📍 Generated SVG path:', pathString ? 'SUCCESS' : 'FAILED');
        //    console.log('📍 Path string length:', pathString?.length);
        //} else {
        //    console.log('❌ landBoundary or geometry is missing');
        //}
        
        const zoomDisplaySize = this.props.isZoomed ? this.getZoomDisplaySize() : null;
        const svgWidth = zoomDisplaySize ? zoomDisplaySize.width : this.mapAreaWidth;
        const svgHeight = zoomDisplaySize ? zoomDisplaySize.height : this.mapAreaHeight;
        const zoomLegendWidth = 320;

        return (

            <div className={(this.props.isCongress && !this.props.factSheet) ? this.props.isDetailedDistrict ? '' : 'congress-mapcontainer center_this' : 'mapcontainer'}>
                {!this.props.isDetailedDistrict && this.props.isZoomed &&
                    <div className="mapFilter">
                        <RadioGroup value="All" name="type" onChange={this.handleChange} horizontal>
                            <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value="all">All</RadioButton>
                            <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value="vendor">Vendor</RadioButton>
                            <RadioButton pointColor="indigo" iconSize={20} iconInnerSize={10} padding={5} value="subaward">Subaward</RadioButton>
                        </RadioGroup>
                    </div>
                }

                {!this.props.isDetailedDistrict && this.props.isZoomed && <ZoomHelp className="zoomhelp zoomed" chart_no={chartNo} />}

                <div className={
                    this.props.factSheet && this.props.isCongress ? "factsheet-map-panel"
                        : !this.props.factSheet && !this.props.isEmployee ? `mapContent${this.props.isZoomed ? " mapContent--zoomed" : ""}`
                            : this.props.isEmployee ? "employeeMapContent" : ""
                }>
                    <svg width={svgWidth} height={svgHeight} ref={this.mapAreaRef}
                        className={this.props.isCongress ? '' : ''}
                        viewBox={this.getSvgViewBox()}
                        >
                        <rect
                            width={this.mapAreaWidth}
                            height={this.mapAreaHeight}
                            onClick={this.reset}
                            //only inline style works with download otherwise there would be a black rect behind the map
                            style={{ fill: 'none', pointerEvents: 'all' }} />
                        {
                            <defs>
                                <path
                                    id={clipPathId}
                                    d={this.getGeoPath(this.state.landBoundary)(this.state.landBoundary.geometry)}
                                />
                            </defs>

                        }
                        {
                            <clipPath id={`clip-${clipPathId}`}>
                                <use xlinkHref={`#${clipPathId}`} />
                            </clipPath>
                        }

                        {
                            <g
                                clipPath={`url(#clip-${clipPathId})`}
                                //panning and wheel zoom
                                transform={
                                    this.props.isEmployee ? `translate(0,0)` :
                                        this.props.factSheet ? `translate(0,0)` :
                                            this.state.zoomTransform && `translate(${this.state.zoomTransform.x}, ${this.state.zoomTransform.y}) scale(${this.state.zoomTransform.k})`}

                            >
                                <Map
                                    stateFips={this.props.state_fips}
                                    factSheet={this.props.factSheet}
                                    isEmployee={this.props.isEmployee}
                                    isCongress={this.props.isCongress}
                                    tablename={this.state.tablename}
                                    mapAreaWidth={this.mapAreaWidth}
                                    mapAreaHeight={this.mapAreaHeight}
                                    data={(this.props.isEmployee) ? this.props.mapData : this.getSpending()}
                                    colorScale={this.getColorScale()}
                                    isZoomed={this.props.isZoomed}
                                    isInState={this.props.isInState}
                                    isHovered={this.state.hover}
                                    shapeData={this.state.shapeData}
                                    handleMouseEnter={this.handleMouseEnter}
                                    handleMouseLeave={this.handleMouseLeave}
                                    getGeoPath={this.getGeoPath}
                                    handleClick={this.handleClick}
                                    isDetailedDistrict={this.props.isDetailedDistrict}
                                />

                                {this.props.isInState && this.state.landBoundary && (
                                    <path
                                        d={this.getGeoPath(this.state.landBoundary)(this.state.landBoundary.geometry)}
                                        fill="none"
                                        stroke="#D3D3D3"
                                        strokeWidth="3"
                                        style={{ pointerEvents: 'none' }}
                                    />
                                )}
                            </g>
                        }
                    </svg>


                    {this.props.factSheet && this.props.isCongress ? (
                        <div className="factsheet-map-overlay">
                            {this.state.hover &&
                                <MapTooltip
                                    USState={this.props.USState}
                                    data={this.state.tooltipData}
                                    hoverFeature={this.state.hoverFeature}
                                    tablename={this.state.tablename}
                                    isCongress={this.props.isCongress}
                                    isEmployee={this.props.isEmployee}
                                    agg={this.props.agg}
                                />}
                            {!this.props.mapHasNoLegend &&
                                <MapLegend
                                    factSheet={this.props.factSheet}
                                    mapAreaWidth={this.mapAreaWidth}
                                    mapAreaHeight={this.mapAreaHeight}
                                    mapAreaPadding={20}
                                    legendAreaWidth={300}
                                    legendTitleHeight={15}
                                    legendPadding={10}
                                    legendBoxPadding={5}
                                    legendCellHeight={10}
                                    legendCellWidth={20}
                                    legendBoxWidth={150}
                                    legendLineHeight={15}
                                    legendBoxMargin={5}
                                    legendBoxHeight={(this.colorScheme.length + 1) * this.legendLineHeight - this.legendCellHeight + 2 * this.legendBoxPadding}
                                    colorScale={this.getColorScale()}
                                    tablename={this.state.tablename}
                                    colorScheme={this.colorScheme}
                                    isInstate={this.props.isInState}
                                    isEmployee={this.props.isEmployee}
                                    homeStateEmployeeCount={this.homeStateEmployeeCount}
                                    otherStateEmployeeCounts={this.otherStateEmployeeCounts()}
                                    isCongress={this.props.isCongress}
                                    isZoomed={this.props.isZoomed}
                                    agg={this.props.agg}
                                />}
                        </div>
                    ) : (
                        <>
                            {(!this.props.mapHasNoLegend) &&
                                <MapLegend
                                    factSheet={this.props.factSheet}
                                    mapAreaWidth={this.mapAreaWidth}
                                    mapAreaHeight={this.mapAreaHeight}
                                    mapAreaPadding={20}
                                    legendAreaWidth={this.props.isEmployee ? 200 : this.props.isZoomed ? zoomLegendWidth : 300}
                                    legendTitleHeight={15}
                                    legendPadding={10}
                                    legendBoxPadding={5}
                                    legendCellHeight={this.props.isEmployee ? 18 : 10}
                                    legendCellWidth={20}
                                    legendBoxWidth={150}
                                    legendLineHeight={this.props.isEmployee ? 20 : this.props.isZoomed ? 20 : 15}
                                    legendBoxMargin={5}
                                    legendBoxHeight={(this.colorScheme.length + 1) * this.legendLineHeight - this.legendCellHeight + 2 * this.legendBoxPadding}
                                    colorScale={this.getColorScale()}
                                    tablename={this.state.tablename}
                                    colorScheme={this.colorScheme}
                                    isInstate={this.props.isInState}
                                    isEmployee={this.props.isEmployee}
                                    homeStateEmployeeCount={this.homeStateEmployeeCount}
                                    otherStateEmployeeCounts={this.otherStateEmployeeCounts()}
                                    isCongress={this.props.isCongress}
                                    isZoomed={this.props.isZoomed}
                                    agg={this.props.agg}
                                />}

                            {(this.state.hover) &&
                                <MapTooltip
                                    USState={this.props.USState}
                                    position={this.state.tooltipPosition}
                                    data={this.state.tooltipData}
                                    hoverFeature={this.state.hoverFeature}
                                    tablename={this.state.tablename}
                                    isCongress={this.props.isCongress}
                                    isEmployee={this.props.isEmployee}
                                    agg={this.props.agg}
                                />}
                        </>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    UserState: state.userProperties,
    selectedCongressId: state.detailedDistrictReportProperties.selectedCongressId
});

const mapDispatchToProps = dispatch => ({
    getAllSpending: (displayId, vintage) => dispatch(getAllSpending(displayId, vintage)),
    getDetailedDistrictReportDisplayData: (displayId, congressId, vintage) => dispatch(getDetailedDistrictReportDisplayData(displayId, congressId, vintage)),
    downloadDetailedDistrictReport: congressReportData => dispatch(downloadDetailedDistrictReport(congressReportData)),
    setSelectedDistrictId: congressId => dispatch(setSelectedDistrictId(congressId))
});

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);